import { CALLABO_API_BASE_URL } from '@/modules/Paths';
import { CallaboApiClient } from 'callabo-api/src/CallaboApiClient';
import { useEffect, useRef } from 'react';
import { create } from 'zustand';

export type Settings = {
  maxRecordFileSize: number;
  maxRecordDuration: number;
  minRecordDuration: number;
};

export const useSettingsStore = create<Settings>(() => ({
  maxRecordFileSize: 0,
  maxRecordDuration: 0,
  minRecordDuration: 0,
}));

export const getCallaboSettings = (): Settings => {
  return useSettingsStore.getState();
};

export const useCallaboSettings = (): Settings => {
  return useSettingsStore();
};

const setCallaboSettings = async (settings: Settings): Promise<void> => {
  useSettingsStore.setState(settings);
};

export function useFetchCallaboSettings() {
  const fetchingRef = useRef(false);
  useEffect(() => {
    async function fetchSettings() {
      if (fetchingRef.current) {
        return;
      }

      fetchingRef.current = true;
      try {
        const apiClient = new CallaboApiClient({
          BASE: CALLABO_API_BASE_URL,
        });

        const settings = await apiClient.service.getServiceSettingsV1SettingsGet();
        setCallaboSettings({
          maxRecordFileSize: settings.max_record_filesize,
          maxRecordDuration: settings.max_record_duration,
          minRecordDuration: settings.min_record_duration,
        });
      } catch (error) {
        //
      } finally {
        fetchingRef.current = false;
      }
    }

    fetchSettings();
  }, []);
}
